<template>
    <div>
        <b-modal id="upload-pt" :title="uploadObject.Id ? 'Düzenle' : 'Ekle'" no-close-on-esc no-close-on-backdrop>
            <ohs-education-create v-model="uploadObject" v-on:add-session="addSession" v-on:remove-session="removeSession" :total-hours="totalSessionHours"/>
            <template #modal-footer><v-executer :loading="loading" :action="upload">Kaydet</v-executer></template>
        </b-modal>
        <b-modal id="view-sessions-modal" title="Oturum Detayları" hide-footer>
            <session-viewer v-if="selectedSessions.length" :sessions="selectedSessions" />
            <div v-else class="text-center">
                Bu eğitime atanmış bir oturum bulunmuyor.
            </div>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    :add-callback="createNew"
                    :settings="false"
                    pagination="server"></v-table>
    </div>
</template>

<script>
import OHSEducationApi from '@/api/ohs-education'
import OHSEducationCreate from './components/OHSEducationCreate.vue'
import Additional from '@/utilities/additional'
import SessionViewer from './components/SessionViewer.vue'
import moment from 'moment'

export default {
    components:{
        'ohs-education-create':OHSEducationCreate,
        'session-viewer': SessionViewer
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            fields:[
                {name:'İSG Eğitimi',key:'OHSEducationName',thClass:'w-34'},
                // {name:'Başlangıç Zamanı',key:'StartDateTimeStr',thClass:'w-33'},
                // {name:'Bitiş Zamanı',key:'EndDateTimeStr',thClass:'w-33'},
                {name: 'Oturum Sayısı', key: 'SessionCount', tdClass: 'text-center', thClass:'text-center'},
                {name:'Geçerlilik Başlangıç Tarihi',key:'ValidityStartDateStr',thClass:'w-33'},
                {name:'Geçerlilik Bitiş Tarihi',key:'ValidityEndDateStr',thClass:'w-33'}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"success",action:this.download, condition:item => item.FilePath },
                { text: "Oturumlar", key: "view-sessions", icon: "ClockIcon", variant: "info", action: this.showSessionsModal },
            ],
            loading:false,
            uploadObject:{
                Id:null,
                OHSEducationId:null,
                EmployeeId:this.id,
                // StartDateTime:null,
                // EndDateTime:null,
                ValidityStartDate:null,
                ValidityEndDate:null,
                File:null,
                Sessions: []
            },
            selectedSessions: []
        }
    },
    computed: {
        totalSessionHours() {
            if (!this.uploadObject.Sessions || this.uploadObject.Sessions.length === 0) {
                return 0;
            }

            const total = this.uploadObject.Sessions.reduce((accumulator, session) => {
                if (session.StartDateTime && session.EndDateTime) {
                    const start = moment(session.StartDateTime, 'YYYY-MM-DD HH:mm');
                    const end = moment(session.EndDateTime, 'YYYY-MM-DD HH:mm');

                    if (end.isAfter(start)) {
                        const duration = moment.duration(end.diff(start));
                        return accumulator + duration.asHours(); 
                    }
                }
                return accumulator;
            }, 0);

            return total.toFixed(1);
        }
    },
    methods:{
        clearForm(){
            this.uploadObject.Id = null
            this.uploadObject.OHSEducationId = null
            // this.uploadObject.StartDateTime = null
            // this.uploadObject.EndDateTime = null
            this.uploadObject.Sessions = []
            this.uploadObject.ValidityStartDate = null
            this.uploadObject.ValidityEndDate = null
            this.uploadObject.File = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('upload-pt')
        },
        provider(data){
            return OHSEducationApi.Employee.Table({
                ...data,
                EmployeeId:this.id
            }).then(res => {
                if (res.data && res.data.Success && res.data.Data && res.data.Data.Data) {
                    res.data.Data.Data.forEach(item => {
                        item.SessionCount = item.Sessions ? item.Sessions.length : 0;
                    });
                }
                return { data: res.data };
            });
        },
        upload(){
            const formData = new FormData()
            formData.append('EmployeeId',this.id)
            if(this.uploadObject.OHSEducationId) formData.append('OHSEducationId',this.uploadObject.OHSEducationId)
            // if(this.uploadObject.StartDateTime) formData.append('StartDateTime',this.uploadObject.StartDateTime)
            // if(this.uploadObject.EndDateTime) formData.append('EndDateTime',this.uploadObject.EndDateTime)
            if (this.uploadObject.Id) formData.append('Id', this.uploadObject.Id);

            this.uploadObject.Sessions.forEach((session, index) => {
                if(session.StartDateTime && session.EndDateTime) {
                    formData.append(`Sessions[${index}].StartDateTime`, session.StartDateTime)
                    formData.append(`Sessions[${index}].EndDateTime`, session.EndDateTime)
                }
            })

            if(this.uploadObject.ValidityStartDate) formData.append('ValidityStartDate',this.uploadObject.ValidityStartDate)
            if(this.uploadObject.ValidityEndDate) formData.append('ValidityEndDate',this.uploadObject.ValidityEndDate)
            if(this.uploadObject.File != null && typeof this.uploadObject.File === 'object') {
                formData.append('File',this.uploadObject.File)
            }
            this.loading = true
            const request = this.uploadObject.Id 
                ? OHSEducationApi.Employee.Update(formData) 
                : OHSEducationApi.Employee.Create(formData);

            request.then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload-pt')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.OHSEducationName} isimli ISG eğitim belgesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    OHSEducationApi.Employee.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        download(item){
            Additional.DownloadTab(item.FilePath)
        },
        addSession(){
            if (!this.uploadObject.Sessions) {
                this.uploadObject.Sessions = []; 
            }
            this.uploadObject.Sessions.push({
                StartDateTime: null,
                EndDateTime: null
            })
        },
        removeSession(index){
            this.uploadObject.Sessions.splice(index, 1);
        },
        showSessionsModal(item) {
            this.selectedSessions = item.Sessions || [];
            this.$showModal('view-sessions-modal');
        },
        edit(item) {
            this.clearForm()
            this.uploadObject.Id = item.Id
            this.uploadObject.OHSEducationId = item.OHSEducationId
            
            this.uploadObject.Sessions = item.Sessions.map(s => ({
                StartDateTime: s.StartDateTime.replace('T', ' ').substring(0, 16),
                EndDateTime:   s.EndDateTime  .replace('T', ' ').substring(0, 16)
            }));

            this.uploadObject.ValidityStartDate = item.ValidityStartDate;
            this.uploadObject.ValidityEndDate = item.ValidityEndDate;
            this.uploadObject.File = item.FilePath;
            this.$showModal('upload-pt')
        }
    }
}
</script>